/**
 * Can be used for ENV and ESS score
 * @param score bewteen 0 and 1
 * @returns A B C D E ''
 */
export function getScoreLetterFromScore(score: number): string {
  if (score > 0.8 && score <= 1) {
    return 'A';
  } else if (score > 0.6) {
    return 'B';
  } else if (score > 0.4) {
    return 'C';
  } else if (score > 0.2) {
    return 'D';
  } else if (score > 0) {
    return 'E';
  } else {
    return '';
  }
}
